import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { TrackingSearch } from 'src/app/core/services/tracking/models/tracking-object.interface';
import { updateFilterResults } from 'src/app/store/common/common.actions';

@Injectable({
  providedIn: 'root'
})
export class SelectablesSearchService {
  private readonly visibilitySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public constructor(private readonly store: Store) {}

  public get selectablesSearchVisibility$(): Observable<boolean> {
    return this.visibilitySubject.asObservable();
  }

  public setSelectablesSearchVisibility(visible: boolean): void {
    // notify all observers about a visiblity change
    this.visibilitySubject.next(visible);
  }

  public setFilterData(filterResults: TrackingSearch): void {
    this.selectablesSearchVisibility$.subscribe(visible => {
      if (visible || (!visible && !filterResults.term)) {
        this.store.dispatch(updateFilterResults({ filterResults }));
      }
    });
  }
}
